import styled from '@emotion/styled';

export const ChatWrapper = styled.div`
  flex-grow: 1;
  position: relative;
  border-left: 1px solid #eee;
  height: 100%;
  overflow: hidden;
  header {
    text-align: center;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 0.8rem;
    font-weight: 500;
    color: rgba(var(--ion-color-dark-rgb), 0.6);
    padding: 0 35px 10px;
    margin-bottom: 10px;
    margin-top: 0;

    i {
      font-size: 18px;
      margin: 0 7px 0 -10px;
    }
  }
  &.chat-prompt {
    .comment-feed {
      border-top: 1px solid #eee;
    }
  }
  &.chat-sonar {
    overflow: hidden;
    .comment-input {
      border: 1px solid #ececec;
      border-radius: 8px;
      margin: 0 auto;
      width: calc(100% - 20px);
      left: 0;
      right: 0;
      bottom: 10px;
    }
    .input-error {
      bottom: 70px;
      &.visible {
        transform: translateY(10px);
      }
    }

    border-bottom: 1px solid #eee;
    border-bottom-left-radius: 8px;
  }
  &.chat-responses {
    header {
      justify-content: flex-end;
      padding: 5px 60px 8px 16px;
      margin: 0;
      border-bottom: 1px solid #eee;
      box-shadow: var(--chakra-shadows-sm);
      position: relative;
      z-index: 1;
    }
  }

  .comment-feed {
    height: calc(100% - 90px);

    height: calc(100% - 90px);
    .feed-inner {
      height: 100%;
      /* padding-top: 10px; */
      /* padding-bottom: 50px; */

      .no-comments {
        display: flex;
        padding: 30px;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        color: var(--ion-color-medium);
        font-size: 0.9rem;
        i {
          display: block;
          margin: 20px 0;
        }
      }
      .comment-replies {
        opacity: 0;
        height: 0;
        pointer-events: none;
        list-style: none;
        margin: 0;
        padding: 0;
        display: none;
        ion-avatar {
          width: 25px;
          height: 25px;
          margin: 2px 10px 0 0;
        }
        &.open {
          opacity: 1;
          display: block;
          height: 100%;
          pointer-events: auto;
          padding: 10px 2px 30px;
        }
        li {
          display: flex;
          align-items: flex-start;
          &.li-list-end {
            justify-content: flex-end;
            border-bottom: 1px solid #eee;
          }
        }
      }
    }
    .comment-action {
      margin: 25px 10px;
      display: flex;
      align-items: center;
      max-width: 30px;
      padding: 0;
      ion-icon {
        font-size: 24px;
      }
    }
  }
`;

export const CommentDate = styled.span`
  margin: 0 10px;
  color: rgba(var(--ion-color-dark-rgb), 0.5);
  font-size: 0.7rem;
`;

export const CommentsWrapper = styled.div`
  position: absolute;
  pointer-events: none;
  bottom: 0;
  opacity: 0;
  left: 0;
  right: 0;
  transition: opacity 0.2s, transform 0.4s, visibility 0s;
  overflow: hidden;
  max-height: 0;
  background: #fff;
  z-index: 2;
  border-radius: 22px;
  top: 0;
  transform: translateY(240px);
  border-top: 2px solid rgba(var(--ion-color-primary-rgb), 0);
  text-align: left;
  visibility: hidden;
  font-family: var(--font-family-alt);

  .newcomment-enter {
    opacity: 0.01;
    transform: translateY(100px);
  }
  .newcomment-enter-active {
    opacity: 1;
    transform: translateY(0);
    transition: 0.5s ease-in-out;
  }

  &.open {
    border-top: none;
    height: auto;
    max-height: 500px;
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0);
    visibility: visible;
    display: flex;
    flex-direction: column;
  }
  h4 {
    font-size: 0.8rem;
    color: #444;
    width: 100%;
    padding: 3px;
    margin-top: -6px;
    height: 45px;
    margin-bottom: 10px;
    font-weight: 400;
    display: flex;
    justify-content: center;
    align-items: center;
    .header-icon {
      font-size: 16px;
      margin-left: -15px;
      margin-right: 5px;
      opacity: 0.7;
    }
  }
  .comment-feed {
    height: calc(100% - 70px);
    .feed-inner {
      padding-top: 10px;
      padding-bottom: 50px;

      .no-comments {
        display: flex;
        padding: 30px;
        justify-content: center;
        align-items: center;
        color: var(--ion-color-medium);
      }
      .comment-replies {
        opacity: 0;
        height: 0;
        pointer-events: none;
        list-style: none;
        margin: 0;
        padding: 0;
        display: none;
        ion-avatar {
          width: 25px;
          height: 25px;
          margin: 2px 10px 0 0;
        }
        &.open {
          opacity: 1;
          display: block;
          height: 100%;
          pointer-events: auto;
          padding: 10px 2px 30px;
        }
        li {
          display: flex;
          align-items: flex-start;
          &.li-list-end {
            justify-content: flex-end;
            border-bottom: 1px solid #eee;
          }
        }
      }
    }
    .comment-action {
      margin: 25px 10px;
      display: flex;
      align-items: center;
      max-width: 30px;
      padding: 0;
      ion-icon {
        font-size: 24px;
      }
    }
  }
  .btn-close {
    display: flex;
    position: absolute;
    right: 0;
    left: 0;
    margin: 0;
    transition: opacity 0.1s;
    display: flex;
    align-items: center;
    opacity: 1;
    color: #fff;
    padding: 0 20px 3px;
    justify-content: center;
    width: 110px;
    z-index: 10;
    --box-shadow: none;
    --border-radius: 0 0 5px 5px;

    ion-icon {
      font-size: 24px;
    }
    &:hover,
    &:focus {
      opacity: 1;
    }
  }
`;

export const CommentFeedWrapper = styled.div`
  --comment-font-size: 0.85rem;
  height: 100%;
  ion-list {
    padding: 0;

    ion-label {
      margin: 9px 0;
    }

    .btn-view-replies {
      font-weight: 700;
      color: rgba(var(--ion-color-medium-rgb), 0.7);
      display: flex;
      align-items: center;
      font-size: 0.75rem;
      margin: 10px 0 0;
      letter-spacing: -0.03em;
      ion-icon {
        margin-left: 5px;
      }
      &:hover {
        color: rgba(var(--ion-color-medium-rgb), 1);
      }
    }

    ion-item {
      align-items: flex-start;
      border-bottom: 1px solid #eee;
      padding: 5px 5px 5px 2px;
      --highlight-height: 0;
      --padding-start: 5px;
      --inner-padding-end: 0;

      ion-avatar {
        margin-top: 12px;
        border: 1px solid #9696966e;
        border-radius: 50%;
        padding: 3px;
        margin-right: 10px;
        box-sizing: content-box;
        margin-left: 0;
        width: 30px;
        height: 30px;
      }
    }
  }
  .comment-media {
    height: 130px;
    margin: 10px 5px 12px;
    img {
      height: 100%;
      width: auto;
      border-radius: 10px;
    }
  }

  .comment-username {
    font-size: 0.9rem;
    font-weight: 700;
    color: rgba(var(--ion-color-dark-rgb), 0.7);
    margin-bottom: 5px;
    margin-top: 5px;
    display: flex;
    align-items: center;
  }
  .comment-body-text {
    font-family: var(--font-family-alt);
    font-size: var(--comment-font-size);
    color: #555;
    white-space: pre-wrap !important;
    word-break: break-word;
    padding: 3px 0;
    text-align: left;
    p {
      display: inline;
    }
    .tags,
    .tag {
      display: inline-block;
      color: var(--ion-color-primary);
      font-weight: 600;
      padding-right: 1px;
    }
    .btn {
      margin-left: 6px;
      border-radius: 50%;
      padding: 1px;
      background: rgba(var(--ion-color-dark-rgb), 0);
      margin: 0;

      &.btn-reply {
        position: relative;
        top: 2px;
      }
      ion-icon,
      i {
        font-size: 15px;
        color: rgba(var(--ion-color-dark-rgb), 0.5);
        transition: 0.15s;
      }
      &:hover {
        ion-icon,
        i {
          color: var(--ion-color-primary);
        }
      }
      &.btn-edit {
        padding: 1px 7px;
        margin: 3px 10px;
        font-weight: 600;
        border-radius: 5px;
        color: orange;
        font-size: 0.8rem;
        i {
          font-size: 18px;
          color: orange;
        }
      }
    }
  }
`;

export const AddCommentInput = styled.section`
  height: 50px;
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 5px 15px;
  border-top: 1px solid #ddd;
  font-size: 0.9rem;
  font-weight: 600;
  background-color: var(--ion-color-light);
  text-align: left;
  .input-clear-icon {
    width: 22px;
    height: 22px;
    background-size: 18px;
    margin-right: 10px;
    margin-left: 5px;
    opacity: 0.5;
    transition: all 0.2s;
    &:hover {
      opacity: 1;
    }
  }
  ion-icon {
    font-size: 24px;
  }
  .rs-icon {
    color: rgba(var(--ion-color-dark-rgb), 0.6);
    cursor: pointer;
    font-size: 17px;
    margin-right: 10px;
    &:hover {
      color: rgba(var(--ion-color-primary-rgb), 1);
    }
  }
`;

export const AddCommentInputError = styled.div`
  position: absolute;
  width: 90%;
  opacity: 0;
  transition: 0.35s;
  pointer-events: none;
  transform: translateY(50px);
  color: var(--ion-color-light);
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  padding: 10px;
  min-height: 30px;
  font-weight: 600;
  bottom: 0;
  box-shadow: 0px -1px 9px #0000006b;
  background: #de334a;
  margin: 0 auto;
  right: 0;
  border-radius: 8px 8px 0 0;
  &.visible {
    transform: translateY(-50px);
    opacity: 1;
  }
`;
